import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  Validators,
  ValidatorFn,
  FormGroup,
  ValidationErrors,
  FormControl,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractFormDialogData,
  AbstractFormDialog,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';

export interface CopyTemplatesByYearDialogData extends AbstractFormDialogData {
  cropYears: number[];
}

export interface CopyTemplatesByYearDialogResult {
  sourceYear: number;
  destinationYear: number;
}

export const cropYearValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const sourceYear = control.get('sourceYear');
  const destinationYear = control.get('destinationYear');

  if (
    sourceYear &&
    sourceYear.value &&
    destinationYear &&
    destinationYear.value &&
    typeof sourceYear.value === 'number' &&
    typeof destinationYear.value === 'number'
  ) {
    return destinationYear.value <= sourceYear.value ? { yearInvalid: true } : null;
  }

  return null;
};

@Component({
  selector: 'app-copy-templates-by-year-dialog',
  templateUrl: './copy-templates-by-year-dialog.component.html',
  standalone: false,
})
export class CopyTemplatesByYearDialogComponent extends AbstractFormDialog<CopyTemplatesByYearDialogResult> {
  data = inject<CopyTemplatesByYearDialogData>(MAT_DIALOG_DATA);
  private readonly formBuilder = inject(FormBuilder);
  protected readonly mdDialogRef =
    inject<
      MatDialogRef<
        CopyTemplatesByYearDialogComponent,
        AbstractDialogResultData<CopyTemplatesByYearDialogResult>
      >
    >(MatDialogRef);

  sourceYear: FormControl<number | undefined>;
  formGroup = this.formBuilder.group(
    {
      sourceYear: [new FormControl<number | undefined>(undefined), Validators.required],
      destinationYear: [new FormControl<number | undefined>(undefined), Validators.required],
    },
    { validators: cropYearValidator },
  );
}
